import * as React from "react";
import Drawer from "@mui/material/Drawer";
import "./styles.scss";
import { useEffect, useState } from "react";
import { toggleDrawer } from "../../utils/utils";
import NewButton from "../common/NewButton/NewButton";
import { CloseOutlined } from "@mui/icons-material";
import {
  Stack,
  Box,
  Typography,
  IconButton,
  FormControlLabel,
  FormGroup,
  styled,
  Switch,
  alpha,
} from "@mui/material";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";
import { useDispatch } from "react-redux";
import { primary } from "../../theme/palette";
import NewClient from "./NewClient";
import { resetSelectedClient } from "../../redux/features/clientSlice";
import { ClientType } from "../../types/genericType";

const ColoredSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: primary,
    "&:hover": {
      backgroundColor: alpha("##606ADD", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: primary,
  },
}));

type NewClientDrawerProps = {
  getClientsData: Function;
  selectedClient: ClientType;
  updateSelectedClient: Function;
  openEditDrawer: boolean;
  setOpenEditDrawer: Function;
};

const NewClientDrawer = (props: NewClientDrawerProps) => {
  const { getClientsData, openEditDrawer, setOpenEditDrawer, selectedClient } =
    props;
  const [open, setOpen] = useState(false);
  const [editFlow, setEditFlow] = useState(false);
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [active, setActive] = useState(selectedClient?.isActive);
  const dispatch = useDispatch();

  const handleDrawerOpen = toggleDrawer<React.KeyboardEvent | React.MouseEvent>(
    true,
    setOpen
  );

  const handleDrawerClose = () => {
    setEditFlow(false);
    setOpen(false);
    setOpenEditDrawer(false);
  };

  useEffect(() => {
    if (openEditDrawer) {
      setEditFlow(true);
      setOpen(openEditDrawer);
    }
  }, [openEditDrawer]);

  useEffect(() => {
    if (!editFlow) {
      dispatch(resetSelectedClient());
    }
  }, [editFlow]);

  useEffect(() => {
    if (selectedClient) {
      setActive(selectedClient.isActive);
    }
  }, [selectedClient]);

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          {editFlow ? "Edit Client" : "New Client"}
        </Typography>
        {editFlow && (
          <FormGroup>
            <FormControlLabel
              control={
                <ColoredSwitch
                  checked={active}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setActive(event.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label={active ? "Active" : "Inactive"}
            />
          </FormGroup>
        )}
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleDrawerClose}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
      </Box>
      <NewClient
        getClientsData={getClientsData}
        setOnTxnSuccess={setOnSuccess}
        setSnackbarMsg={setSnackbarMsg}
        editFlow={editFlow}
        selectedClient={selectedClient}
        handleDrawerClose={handleDrawerClose}
        isActive={active}
      />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        <NewButton
          title="NEW CLIENT"
          handleBtnClick={handleDrawerOpen}
          type="contained"
        />
        <Drawer
          anchor="right"
          variant="temporary"
          onClose={handleDrawerClose}
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            "&.MuiDrawer-root .MuiDrawer-paper": {
              marginTop: "65px",
              width: "436px",
            },
          }}
        >
          {drawerComp}
        </Drawer>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
      </React.Fragment>
    </div>
  );
};

export default NewClientDrawer;
